export const triggerConfetti = () => {
  const duration = 3000;
  const animationEnd = Date.now() + duration;
  const colors = ['#013EFB', '#2563EB', '#059669', '#F59E0B', '#7C3AED', '#EC4899'];

  const frame = () => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return;
    }

    const particleCount = 3;

    for (let i = 0; i < particleCount; i++) {
      createConfetti(colors[Math.floor(Math.random() * colors.length)]);
    }

    requestAnimationFrame(frame);
  };

  frame();
};

const createConfetti = (color: string) => {
  const confetti = document.createElement('div');
  confetti.style.position = 'fixed';
  confetti.style.width = '10px';
  confetti.style.height = '10px';
  confetti.style.backgroundColor = color;
  confetti.style.left = Math.random() * window.innerWidth + 'px';
  confetti.style.top = '-10px';
  confetti.style.opacity = '1';
  confetti.style.zIndex = '9999';
  confetti.style.pointerEvents = 'none';
  confetti.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
  confetti.style.transform = `rotate(${Math.random() * 360}deg)`;

  document.body.appendChild(confetti);

  const animation = confetti.animate([
    {
      transform: `translate(0, 0) rotate(0deg)`,
      opacity: 1
    },
    {
      transform: `translate(${(Math.random() - 0.5) * 200}px, ${window.innerHeight}px) rotate(${Math.random() * 720}deg)`,
      opacity: 0
    }
  ], {
    duration: 3000 + Math.random() * 2000,
    easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  });

  animation.onfinish = () => {
    confetti.remove();
  };
};
